export default __webpack_public_path__ + "static/soehne-web-buch-a4af5947fdc72bc7af89315a7f31a469.woff";